'use strict';

const IconBadgeView = require('common/ui/view/svg/icon-badge');
const CommentCollectionRepository = require('communication/domain/repository/comment-collection');

const CommentCounterView = IconBadgeView.extend({
    initialize: function (params) {
        CommentCounterView.__super__.initialize.call(this, params);

        const project = this.getOption('project');
        const key = this.getOption('key');
        const hasComment = this.getOption('hasComment');

        const onLoaded = (comments) => {
            this._badge = {
                content: function () {
                    return comments.getTotalCount();
                },
                listen: function (onChange) {
                    comments.on('change:totalCount', onChange);
                }
            };

            this.listenBadgeChange();
            this.onChangeBadge();
        };

        if (hasComment) {
            CommentCollectionRepository
                .find(project)
                .byKey(key)
                .fetchFirstPage()
                .then(onLoaded);
        } else {
            CommentCollectionRepository
                .find(project)
                .byKey(key)
                .buildEmptyCollection()
                .then(onLoaded);
        }
    }
});

module.exports = CommentCounterView;



// WEBPACK FOOTER //
// ./system/ui/view/element-communication/comment-counter-view.js